import React from "react";

export const EDAMainTable = ({ mainTable }) => {
  return (
    <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden flex flex-col mb-5">
      <div className="flex-1 overflow-auto max-h-[500px] [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-thumb]:bg-slate-300 [&::-webkit-scrollbar-thumb]:rounded-full relative">
        <table className="w-full text-sm text-left whitespace-nowrap min-w-max">
          <thead className="sticky top-0 z-20 bg-[#f8fafc] shadow-[0_1px_0_0_#e2e8f0]">
            <tr>
              <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 bg-[#f8fafc]" colSpan="5">Item</th>
              {mainTable.periods.map((p, i) => (
                <th key={i} className="py-2.5 px-4 font-semibold text-[#3b82f6] text-center bg-[#f0f4f8] border-l border-white" colSpan="2">
                  {p.label}
                  {p.isDemo && <span className="ml-2 inline-block bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded text-xs uppercase font-bold tracking-wider">Demo</span>}
                </th>
              ))}
              <th className="py-2.5 px-4 font-semibold text-[#8a5b12] text-center bg-[#efe9dd] border-l border-white" colSpan="2">
                {mainTable.prevPeriodLabel}
              </th>
            </tr>
            <tr>
              <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 bg-[#f8fafc] border-b border-slate-200 top-[34px] sticky">Component</th>
              <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 bg-[#f8fafc] border-b border-slate-200 top-[34px] sticky">Plant</th>
              <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 bg-[#f8fafc] border-b border-slate-200 top-[34px] sticky">Material</th>
              <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 bg-[#f8fafc] border-b border-slate-200 top-[34px] sticky">Description</th>
              <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 bg-[#f8fafc] border-b border-slate-200 top-[34px] sticky">Grouping</th>
              
              {mainTable.periods.map((_, i) => (
                <React.Fragment key={i}>
                  <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 bg-[#f8fafc] text-right border-b  top-[34px] sticky border-l border-slate-100">Qty</th>
                  <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-slate-500 bg-[#f8fafc] text-right border-b border-slate-200 top-[34px] sticky">Value</th>
                </React.Fragment>
              ))}
              <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-[#8a5b12] bg-[#f7f4ee] text-right border-b  top-[34px] sticky border-l border-white">Qty</th>
              <th className="py-2 px-4 text-xs font-semibold uppercase tracking-wider text-[#8a5b12] bg-[#f7f4ee] text-right border-b border-slate-200 top-[34px] sticky">Value</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white">
            {mainTable.rows.map((row, idx) => (
              <tr key={idx} className="hover:bg-slate-50/50">
                <td className="py-2.5 px-4 flex items-center gap-2 text-slate-800 font-medium">
                  <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ backgroundColor: row.color }}></span>
                  {row.component}
                </td>
                <td className="py-2.5 px-4 text-slate-600">{row.plant}</td>
                <td className="py-2.5 px-4 text-slate-800">{row.material}</td>
                <td className="py-2.5 px-4 text-slate-600">{row.description}</td>
                <td className="py-2.5 px-4 text-slate-600">{row.grouping}</td>
                
                {row.values.map((v, i) => (
                  <React.Fragment key={i}>
                    <td className="py-2.5 px-4 text-right text-slate-600 tabular-nums border-l border-slate-50">{v.qty}</td>
                    <td className="py-2.5 px-4 text-right text-slate-800 tabular-nums">{v.value}</td>
                  </React.Fragment>
                ))}
                <td className="py-2.5 px-4 text-right text-slate-600 tabular-nums bg-[#fbf9f4] border-l border-white">{row.prev.qty}</td>
                <td className="py-2.5 px-4 text-right text-slate-800 tabular-nums bg-[#fbf9f4]">{row.prev.value}</td>
              </tr>
            ))}
          </tbody>
          <tfoot className="bg-slate-50 shadow-[0_-1px_0_0_#e2e8f0] sticky bottom-0 z-20">
            <tr>
              <td className="py-3 px-4 font-bold text-slate-900 uppercase" colSpan="5">TOTAL - {mainTable.totalItems} items</td>
              {mainTable.totals.values.map((t, i) => (
                <React.Fragment key={i}>
                  <td className="py-3 px-4 font-bold text-slate-900 text-right whitespace-nowrap border-l border-slate-100">{t.qty}</td>
                  <td className="py-3 px-4 font-bold text-slate-900 text-right whitespace-nowrap">{t.value}</td>
                </React.Fragment>
              ))}
              <td className="py-3 px-4 font-bold text-slate-900 text-right whitespace-nowrap bg-[#f7f4ee] border-l border-white">{mainTable.totals.prev.qty}</td>
              <td className="py-3 px-4 font-bold text-slate-900 text-right whitespace-nowrap bg-[#f7f4ee]">{mainTable.totals.prev.value}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};
